module.exports = __webpack_public_path__ + "img/oaFlowData162@3x.13837764.png";